
import api from "@/api";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import EditActionButtons from "../EditActionButtons.vue";
import EditFrame from "../EditFrame.vue";

@Component({
  components: {
    EditActionButtons,
    EditFrame,
  },
})
export default class StationTimeZone extends Vue {
  @Prop({ default: "Europe/Berlin" })
  readonly bookingTimeZone!: string | null;

  isEditing = false;
  loading = false;
  selectedTimeZone = "Europe/Berlin";
  timeZones: string[] = [];

  mounted(): void {
    this.resetSelection();
    this.loadTimeZones();
  }

  @Watch("bookingTimeZone")
  onBookingTimeZoneChanged(): void {
    if (!this.isEditing) {
      this.resetSelection();
    }
  }

  async loadTimeZones(): Promise<void> {
    this.loading = true;
    try {
      this.timeZones = await api.SystemApi.getTimeZones();
    } catch (e) {
      console.error("Could not load time zones", e);
      this.timeZones = this.selectedTimeZone ? [this.selectedTimeZone] : [];
    } finally {
      this.loading = false;
    }
  }

  onSave(): void {
    this.$emit("save", this.selectedTimeZone);
  }

  onCancel(): void {
    this.resetSelection();
  }

  private resetSelection(): void {
    this.selectedTimeZone = this.bookingTimeZone || "Europe/Berlin";
  }
}
